import { MASTER_DATA_SERVER } from "swfrontend/AppConfigs";

export const validator_messages = {
  STRONG_PASSWORD_HINT:
    "Password should be between 7 to 15 characters with at least one numeric digit, a special character, small letter and a capital letter",
  STRONG_USERNAME: "Username should be between 7 to 15 characters with numeric digit or capital letter or underscore",
  CONFIRM_PASSWORD: "CONFIRM PASSWORD DOES NOT MATCH.",
  SAME_USERNAME: "PLEASE ENTER A DIFFERENT USERNAME",
  USERNAME_EXISTS: "USERNAME ALREADY EXISTS"
};

export const STEPS = {
  prev: "Previous",
  reset_username: "Reset Username",
  reset_password: "Reset Password",
  verification: "Verification"
}

export const UN_AUTHORIZEDTEXT =
  "Sorry, you are not authorized to access this page.";

export const URLS = {
  LOGIN: `/${MASTER_DATA_SERVER.API_PREFIX}/users/crp/customerlogin/`,
  FORGET_PASSWORD: `/${MASTER_DATA_SERVER.API_PREFIX}/users/crp/forgetpassword/`,
  CHECK_USERNAME: `/${MASTER_DATA_SERVER.API_PREFIX}/users/crp/check_username`,
  CHANGE_PASSWORD: `/${MASTER_DATA_SERVER.API_PREFIX}/users/crp/changepassword/`,
  RESET_PASSWORD: `/${MASTER_DATA_SERVER.API_PREFIX}/users/crp/resetpassword/`,
  UPDATE_REGISTRATION: `${process.env.REACT_APP_PROJECT_ROUTE !== "/null" ? process.env.REACT_APP_PROJECT_ROUTE : ""}/UpdateRegistrationForm`,
  RESET_PASSWORD_URL: "ResetPassword",
  FORGET_PASSWORD_URL: "ForgotPassword",
  RESET_USERNAME_URL: "ResetUsername",
  LOGIN_URL: `${process.env.REACT_APP_PROJECT_ROUTE !== "/null" ? process.env.REACT_APP_PROJECT_ROUTE : ""}/Login`,
  PORTAL_URL: `${process.env.REACT_APP_PROJECT_ROUTE !== "/null" ? process.env.REACT_APP_PROJECT_ROUTE : ""}`,
};
